import React from 'react'
import { Link } from 'react-router-dom'

const Textbox = ({ title, titleClick, subtitle, subtitleImage, text, editable, editLink, nonBackground }) => (
  <div className={nonBackground? "text-box non-background" : "text-box"}>
    {title && titleClick ? 
      <h3 onClick={titleClick} className="clickable">{title}</h3> 
    : title?
      <h3>{title}</h3> 
    : null}
    <div className="text content document">
      {editable?
        <Link to={editLink} className="edit"><i className="fas fa-edit"></i></Link>
      :
        null
      }
      {subtitle ? 
        <h4>
          {subtitleImage? <img src={subtitleImage} alt={subtitle} /> : null}
          {subtitle}
        </h4> 
      : null }
      <div dangerouslySetInnerHTML={{__html: text}}></div>
    </div> 
  </div> 
)

export default Textbox



// WEBPACK FOOTER //
// ./src/components/Textbox.js